const Marionette = require('backbone.marionette');

module.exports = Marionette.Behavior.extend({
    initialize: function(options) {
      options = options || {};
      if (!options.tagListName || !options.tagSettingName){
        throw 'tagListName and tagSettingName are required for manageTagSettingsBehavior';
      }
      this.manageTagSettingsBehaviorOptions = options;
      this.view.getUnusedTags = this.getUnusedTags.bind(this);
      this.view.getTagsWithPrettyNames = this.getTagsWithPrettyNames.bind(this);
      this.view.addTagBindings = this.addTagBindings.bind(this);
      this.view.convertToPropertyName = this.convertToPropertyName.bind(this);
    },
    getUnusedTags: function({isPretty} = {}) {
      const tagList = this.getTagDefinitions({isPretty:isPretty});
      return _.filter(tagList, this.isTagUnused.bind(this));
    },
    isTagUnused: function(tag) {
      const camelCaseTag = this.convertToPropertyName(tag);
      return this.getTagSettings()[camelCaseTag] === undefined;
    },
    addTagBindings: function() {
      let self = this;
      let view = self.view;
      let tagNames = _.keys(self.getTagSettings()).concat(self.getTagDefinitions());
      _.forEach(tagNames, (tagName) => {
        if(!view.bindings[`#${tagName}`])
        {
          let binding = {
            observe: `${self.manageTagSettingsBehaviorOptions.tagSettingName}.${tagName}`,
            onSet: function(value) {
                if (!value || /^\s*$/.test(value)) {
                    return null;
                }
                return value;
            },
            onGet: function(value) {
                if (value === null) {
                    return '';
                }
                return value;
            }
          };
          
          if (self.manageTagSettingsBehaviorOptions.showClearCheckbox) {
            binding.attributes =  [{
                name: 'disabled',
                observe: `${self.manageTagSettingsBehaviorOptions.tagSettingName}.clear${tagName}`,
            }];
          }
          view.addBinding(view.model,
            `#${tagName}`, binding);
            if (self.manageTagSettingsBehaviorOptions.showClearCheckbox) {
              view.addBinding(view.model,
                `#clear${tagName}`, {
                  observe: `${self.manageTagSettingsBehaviorOptions.tagSettingName}.clear${tagName}`,
                });
            }
        }
      });
    },
    getTagsWithPrettyNames: function() {
      let tagSettings = this.getTagSettings();
      return _.map(this.getTagDefinitions({isPretty: true}), (tagName) => {
        let propertyName = this.convertToPropertyName(tagName);
        return {
            propertyName: propertyName,
            prettyName: tagName,
            value: tagSettings[propertyName],
            initiallyVisible: propertyName in tagSettings
        };
      });
    },
    getTagDefinitions: function({isPretty} = {}) {
      let tagList = this.view[this.manageTagSettingsBehaviorOptions.tagListName];
        return tagList.map(function (item) {
            if (isPretty) {
                return item.get('name');
            }
            return item.get('id');
        });
    },
    convertToPropertyName: function(prettyTagName){
      let tagList = this.view[this.manageTagSettingsBehaviorOptions.tagListName];
        let result = tagList.findWhere({name: prettyTagName});
        return result.id;
    },
    getTagSettings: function () {
      return this.view.model.get(this.manageTagSettingsBehaviorOptions.tagSettingName);
    }
});
